import React from 'react';

const ProductInfo = ({ 
  series, 
  title, 
  specifications, 
  description,
  onThumbnailClick,
  onGetQuoteClick
}) => {
  const specs = specifications || [
    {
      icon: 'fa-layer-group',
      label: 'Type',
      value: 'Electricity Rail System'
    },
    {
      icon: 'fa-cube',
      label: 'Material',
      value: 'Aluminum & Steel'
    },
    {
      icon: 'fa-building',
      label: 'Application',
      value: 'Residential'
    },
    {
      icon: 'fa-weight-hanging',
      label: 'Capacity',
      value: '160kg / 350lbs'
    },
    {
      icon: 'fa-palette',
      label: 'Custom Options',
      value: 'Colors, Material'
    },
    {
      icon: 'fa-certificate',
      label: 'Certification',
      value: 'EN 81-50 Certified'
    }
  ];

  const paragraphs = description || [
    'The adoption of low-power main machine, realising energy saving.The adoption of the floor plan section design makes the elevator operation more stable',
    'Low standby power consumption, energy saving and environmental protection. Compact size, easy to install, improve space utilisation. Standard contactless technology, immersive enjoyment of silent elevator experience.',
    'Safe and secure operation. Reliable detection accuracy, precise control. Simplified and easy to install and maintain. No need to reset the base station level during power. failure recovery, no loss of position.'
  ];

  return (
    <div id="product-info-panel">
      <div className="mb-6">
        <span className="text-premium-gold text-sm font-semibold tracking-widest uppercase">{series || 'PRO SERIES'}</span>
      </div>
      <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-premium-dark mb-4 leading-tight">
        {title || 'Quiet, intelligent and comfortable ride'}
      </h1>
      <div id="key-specs" className="hidden sm:block bg-premium-light p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
        <h3 className="font-bold text-lg sm:text-xl text-premium-dark mb-4 sm:mb-6">Key Specifications</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          {specs.map((spec, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="w-10 h-10 bg-premium-gold/10 flex items-center justify-center flex-shrink-0">
                <i className={`fa-solid ${spec.icon} text-premium-gold`}></i>
              </div>
              <div>
                <div className="text-sm text-gray-500 mb-1">{spec.label}</div>
                <div className="font-semibold text-premium-dark">{spec.value}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div id="product-description" className="mb-6 sm:mb-8">
        <h3 className="font-bold text-lg sm:text-xl text-premium-dark mb-3 sm:mb-4">Product Description</h3>
        {paragraphs.map((paragraph, index) => (
          <p key={index} className="text-gray-700 leading-relaxed mb-4">
            {paragraph}
          </p>
        ))}
      </div>
      <div id="cta-section" className="space-y-4">
        <button 
          onClick={() => onGetQuoteClick && onGetQuoteClick()}
          className="w-full bg-premium-gold text-premium-dark px-4 sm:px-8 py-4 sm:py-5 text-base sm:text-lg font-bold hover:bg-premium-dark hover:text-white transition-colors flex items-center justify-center space-x-3"
        >
          <i className="fa-solid fa-file-invoice text-lg sm:text-xl"></i>
          <span>Request a Quote</span>
        </button>
        <button className="w-full border-2 border-premium-dark text-premium-dark px-4 sm:px-8 py-4 sm:py-5 text-base sm:text-lg font-bold hover:bg-premium-dark hover:text-white transition-colors flex items-center justify-center space-x-3">
          <i className="fa-solid fa-envelope text-lg sm:text-xl"></i>
          <span>Enquire Now</span>
        </button>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 pt-4">
          <button className="border border-gray-300 text-gray-700 px-6 py-3 text-sm font-medium hover:border-premium-gold hover:text-premium-gold transition-colors flex items-center justify-center space-x-2">
            <i className="fa-solid fa-phone"></i>
            <span>Call Expert</span>
          </button>
          <button className="border border-gray-300 text-gray-700 px-6 py-3 text-sm font-medium hover:border-premium-gold hover:text-premium-gold transition-colors flex items-center justify-center space-x-2">
            <i className="fa-solid fa-download"></i>
            <span>Brochure</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductInfo;
